import apiPdca from '../../../../helpers/apiPdca'
import { history } from '../../../../helpers'
import { loaded, loading, modalAlertaClean, modalAlertaInfo } from '../../../../layout/redux/layoutActions'
import { verificarExisteEmpresaPdca } from '../../base/redux/pdcaBaseActions'

export const setSetupEmpresas = payload => ({
  type: 'PDCA_SETUP_SET_EMPRESAS',
  payload
})

export const setSetupEmpresaSelecionada = payload => ({
  type: 'PDCA_SETUP_SET_EMPRESA_SELECIONADA',
  payload
})

export const setSetupCarregandoLista = payload => ({
  type: 'PDCA_SETUP_SET_CARREGANDO_LISTA',
  payload
})

export const setSetupCarregandoGravacao = payload => ({
  type: 'PDCA_SETUP_SET_CARREGANDO_GRAVACAO',
  payload
})

export const setSetupErro = payload => ({
  type: 'PDCA_SETUP_SET_ERRO',
  payload
})

export const resetSetup = () => ({
  type: 'PDCA_SETUP_RESET'
})

export const setSetupLoad = payload => ({
  type: 'PDCA_SETUP_SET_LOAD',
  payload
})

const normalizarEmpresas = payload => {
  if (!Array.isArray(payload)) {
    return []
  }

  return payload.map(item => ({
    empresaid: item.empresaid,
    empresadescricao: item.empresadescricao
  }))
}




export const listarEmpresasProjetoPdca = (projetoId, nlsPopup) => {
  return async dispatch => {
    try {
      dispatch(loading())
      dispatch(setSetupCarregandoLista(true))
      dispatch(setSetupErro(null))

      const response = await apiPdca.get(`/pdca/listarempresasprojetopdca?projetoId=${projetoId}`)
      const empresas = normalizarEmpresas(response.data)

      dispatch(setSetupEmpresas(empresas))
      dispatch(setSetupEmpresaSelecionada(empresas.length ? empresas[0] : ''))

      return {
        ok: true,
        empresas
      }
    } catch (error) {
      console.error('Erro ao listar empresas do projeto para PDCA:', error)

      dispatch(setSetupEmpresas([]))
      dispatch(setSetupEmpresaSelecionada(''))
      dispatch(setSetupErro(error?.response?.data || error))

      const iderro = error?.response?.data?.iderro

      dispatch(
        modalAlertaInfo({
          ...(iderro === 233 ? nlsPopup[901] : nlsPopup[7]),
          btnAction: () => {
            dispatch(modalAlertaClean())

            if (iderro === 233) {
              history.push('/myprojects')
            }
          },
          show: true,
        })
      )

      return {
        ok: false,
        erro: error?.response?.data || error
      }
    } finally {
      dispatch(setSetupCarregandoLista(false))
      dispatch(loaded())
    }
  }
}



export const listarEmpresasProjetoPdcaOLD = (projetoId, nlsPopup) => {
  return async dispatch => {
    try {
      dispatch(loading())
      dispatch(setSetupCarregandoLista(true))
      dispatch(setSetupErro(null))

      const response = await apiPdca.get(`/Pdca/listarempresasprojetopdca?projetoId=${projetoId}`)
      const empresas = normalizarEmpresas(response.data)

      dispatch(setSetupEmpresas(empresas))
      dispatch(setSetupEmpresaSelecionada(empresas.length ? empresas[0] : ''))

      return {
        ok: true,
        empresas
      }
    } catch (error) {
      console.error('Erro ao listar empresas do projeto para PDCA:', error)

      dispatch(setSetupEmpresas([]))
      dispatch(setSetupEmpresaSelecionada(''))
      dispatch(setSetupErro(error?.response?.data || error))

      dispatch(
        modalAlertaInfo({
          ...nlsPopup[7],
          btnAction: () => dispatch(modalAlertaClean()),
          show: true,
        })
      )

      return {
        ok: false,
        erro: error?.response?.data || error
      }
    } finally {
      dispatch(setSetupCarregandoLista(false))
      dispatch(loaded())
    }
  }
}

export const gravarEmpresaPdca = (empresaSelecionada, projetoId, nlsPopup) => {
  return async dispatch => {
    if (!empresaSelecionada?.empresaid) {
      return {
        ok: false,
        erro: 'empresa_nao_selecionada'
      }
    }

    try {
      dispatch(loading())
      dispatch(setSetupCarregandoGravacao(true))
      dispatch(setSetupErro(null))

      const response = await apiPdca.post(`/Pdca/gravarempresapdca`, {
        empresaid: empresaSelecionada.empresaid
      })

      if (response?.data === 'ok') {
        const revalidacao = await dispatch(verificarExisteEmpresaPdca(projetoId))

        if (revalidacao?.ok) {
          dispatch(resetSetup())
          history.push(`/myprojects/${projetoId}/pdca/priorities`)
        }

        return {
          ok: true
        }
      }

      dispatch(
        modalAlertaInfo({
          ...nlsPopup[7],
          btnAction: () => dispatch(modalAlertaClean()),
          show: true,
        })
      )

      return {
        ok: false,
        erro: response?.data
      }
    } catch (error) {
      console.error('Erro ao gravar empresa PDCA:', error)

      dispatch(setSetupErro(error?.response?.data || error))

      dispatch(
        modalAlertaInfo({
          ...nlsPopup[7],
          btnAction: () => dispatch(modalAlertaClean()),
          show: true,
        })
      )

      return {
        ok: false,
        erro: error?.response?.data || error
      }
    } finally {
      dispatch(setSetupCarregandoGravacao(false))
      dispatch(loaded())
    }
  }
}